{
  "managePlansSection": {
    "availableUpgrades": "available upgrades"
  }
}
